import { render, staticRenderFns } from "./ExpenseEdit.vue?vue&type=template&id=0ec66ec4&"
import script from "./ExpenseEdit.vue?vue&type=script&lang=js&"
export * from "./ExpenseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports